import fusionConstant from './FusionConstant';

const { flex } = window;
const { React } = flex.lib;

function Introductions() {
    const {introductions: introductionList} = fusionConstant;

    return (
        <div className='fusion-landing__introduction'>
            {introductionList.map(item => (
                <div className='fusion-landing__introduction__item' key={item.title}>
                    <span>{item.title}</span>
                    <p>{item.description}</p>
                </div>
            ))}
        </div>
    );
}

module.exports = Introductions;
